import Card from '../../components/ui/Card'
import Badge from '../../components/ui/Badge'

function TeamMemberCard({ member, assignments }) {
  return (
    <Card className="team-card">
      <Card.Header>
        <div>
          <Card.Title>{member.name}</Card.Title>
          <div className="text-sm text-muted">{member.email}</div>
        </div>
        <Badge>{member.role}</Badge>
      </Card.Header>
      <Card.Body>
        <div className="mb-4">
          <div className="text-sm text-muted">AI Tools</div>
          <div className="tag-row">
            {member.ai_tools?.length ? member.ai_tools.map(tool => (
              <span key={tool} className="tag">{tool}</span>
            )) : <span className="text-muted">No tools assigned</span>}
          </div>
        </div>

        <div>
          <div className="text-sm text-muted">Product Assignments</div>
          <ul className="list-compact">
            {assignments.length ? assignments.map(assignment => (
              <li key={assignment.id}>{assignment.products?.name} — {assignment.role}</li>
            )) : <li className="text-muted">No assignments yet</li>}
          </ul>
        </div>
      </Card.Body>
    </Card>
  )
}

export default TeamMemberCard
